import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.css';

class ItemLabel extends Component {
	render() {
		const { minimumSize, price, daysPayables } = this.props;
		return (
			<div className="apple-selector-item-label">
				<span>Minimum lot size</span>
				<span>{minimumSize} kg</span>
				<span>Price</span>
				<span>{price} €/kg</span>
				<span>Days in payables</span>
				<span>{daysPayables}</span>
			</div>
		);
	}
}

ItemLabel.propTypes = {
	minimumSize: PropTypes.number,
	price: PropTypes.number,
	daysPayables: PropTypes.number
};

export default ItemLabel;
